import React, { useEffect, useState } from "react";
import classNames from "classnames";
import s from "./RadioButtons.module.css";
import SVGIcon from "../SVGIcon/SVGIcon";
export const RadioButtonVariants = ["map-list-toggle"] as const;
export const RadioButtonIconTypes = ["list", "map"] as const;
import { useFindOrganizationsMapStore } from "../FindOrganizationsMap/store.jsx";

export type MapListToggle = {
    icon: keyof typeof RadioButtonIconTypes;
};

export const RadioButtonVariantType = ["map-list-toggle"];

type RadioButtonItemType = {
    name: string;
    icon: (typeof RadioButtonIconTypes)[number];
};

const RadioButtons = ({
    variant = "map-list-toggle",
}: {
    variant: (typeof RadioButtonVariants)[number];
}) => {
    const { setShowMap, showMap, expandendResults, organizations } =
        useFindOrganizationsMapStore();
    const [checkedBox, setCheckedBox] = useState(0);
    const rootClasses = classNames(s.root, {
        [s[variant]]: variant,
        [s.disabled]: organizations?.length === 0,
    });

    useEffect(() => {
        if (showMap) {
            setCheckedBox(1);
        } else {
            setCheckedBox(0);
        }
    }, [showMap]);

    const RadioButtonVariantsData = {
        "map-list-toggle": [
            { name: "Visa som lista", icon: "list" },
            { name: "Visa på karta", icon: "map" },
        ],
    };

    const handleCheckedBox = (type: string, index: number) => {
        setCheckedBox(index);

        if (type === "map") {
            setShowMap(true);
        } else {
            setShowMap(false);
        }
    };

    return (
        <div className={rootClasses}>
            <fieldset className={s.fieldset}>
                {RadioButtonVariantsData[variant].map(
                    (radiobutton, index: number) => (
                        <RadioButton
                            key={`radiobutton${radiobutton.name}-${index}`}
                            name={variant}
                            value={radiobutton.name}
                            onClick={() =>
                                handleCheckedBox(radiobutton.icon, index)
                            }
                            icon={radiobutton.icon}
                            index={index}
                            checked={checkedBox === index}
                            disabled={
                                expandendResults &&
                                !!(organizations?.length !== 0)
                                    ? false
                                    : true
                            }
                        />
                    ),
                )}
            </fieldset>
        </div>
    );
};

export default RadioButtons;

const RadioButton = ({
    name,
    checked,
    value,
    onClick,
    index,
    icon,
    disabled = false,
}: {
    name: string;
    value: string;
    checked?: boolean;
    onClick: (index: number) => void;
    index: number;
    icon?: (typeof RadioButtonIconTypes)[number];
    disabled?: boolean;
}) => {
    const containerClasses = classNames(s["input-container"], {
        [s.checked]: checked,
        [s["input-container--disabled"]]: disabled && !checked,
    });
    const labelClasses = classNames(s["input-label"], {
        [s["input-label--checked"]]: checked,
        [s["input-label--disabled"]]: disabled && !checked,
    });
    const inputClasses = classNames(s.input, {});
    const iconClasses = classNames(s.radioIcon, {});
    const iconColors = checked ? null : "--neutral-greyscale-600";

    const disabledIcon =
        disabled && !checked ? "--neutral-greyscale-300" : iconColors;
    return (
        <span onClick={() => onClick(index)} className={containerClasses}>
            {icon && (
                <div>
                    <SVGIcon
                        className={iconClasses}
                        color={disabledIcon}
                        icon={icon}
                    />
                </div>
            )}

            <input
                className={inputClasses}
                type="radio"
                name={name}
                checked={checked}
                value={value}
                disabled={disabled}
            />
            <label className={labelClasses} htmlFor={name}>
                {value}
            </label>
        </span>
    );
};
